module.exports = __webpack_public_path__ + "img/paper_upload.1bee9793.svg";